import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
// 3.20.x 의 text-style 은 default export 가 없고 named only. Color/BackgroundColor 등도
// 여기 통합되어 있지만 명시성을 위해 extension-color 패키지에서 받는다 (re-export).
import { TextStyle } from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import { TextAlign } from "@tiptap/extension-text-align";
import { CustomImage } from "./extensions/custom-image";
import { FootnoteNode } from "./extensions/footnote";
import { SlashCommandExtension } from "./slash-commands/slash-command-extension";

interface EditorExtensionsOptions {
  placeholder?: string;
  onImageUpload?: (file: File) => Promise<string>;
  /** handbook 같이 각주 기능이 필요한 폼에서 켠다. changelog/article 에서는 default off. */
  enableFootnotes?: boolean;
}

export function createEditorExtensions(options: EditorExtensionsOptions) {
  const extensions = [
    StarterKit,
    Underline,
    TextStyle,
    // Color 는 TextStyle 위에 마크를 그린다. types 한정: textStyle. background-color 는 별도.
    Color.configure({ types: ["textStyle"] }),
    // 본문 정렬 — 제목·문단에 적용. 기본(left)은 style 미출력 → 기존 콘텐츠 영향 없음.
    // 정렬 저장은 handbook sanitize(text-align 허용) 가 받쳐줌.
    TextAlign.configure({ types: ["heading", "paragraph"] }),
    CustomImage.configure({ inline: false }),
    Placeholder.configure({
      placeholder: options.placeholder ?? "내용을 입력하세요...",
    }),
    Link.configure({ openOnClick: false }),
    SlashCommandExtension.configure({
      onImageUpload: options.onImageUpload,
    }),
  ];
  if (options.enableFootnotes) {
    extensions.push(FootnoteNode);
  }
  return extensions;
}
